<template lang="pug">
.event-list2
  .title  特别活动
  .waterfall(ref="waterfall")
    .swiper-wrapper(ref="wrapper")
      .swiper-slide.section(v-for="(es,key, i) in events" :key="i")
        .year(v-if="es[0].year") 
          p {{ key.split('-')[0] }}
            span 年
        .timeline
          .bullet(ref="bullet")
            time-bullet(:timestamp="key.split('-')[1]")
        .card(v-for="(e, j) in es" :key="j" ref="card")
          event-card(:active="activeCard === e.idx" @clicked="onClick(e.idx)" :idx="e.idx" :evt="e")
  
</template>
<script>
import Swiper from 'swiper'
import gsap from 'gsap'
import Raf from 'src/helpers/Raf'
import { mapMutations, mapState } from 'vuex'
import EventCard from '@/components/events/EventCard'
import TimeBullet from '@/components/wedgits/TimeBullet2'
import Scrollbar from 'smooth-scrollbar'
import ScrollBooster from 'scrollbooster'
export default {
  name: 'EventList2',
  components: { TimeBullet, EventCard },
  props: {
    activeCard: {},
  },
  data() {
    return {
      progress: 0,
      transitioning: false,
      wrapperTop: 0,
      wrapperEl: null,
      bulletEls: [],
      bulletOrigPos: [],
      bulletH: 0,
      bulletOfs: {
        cur: 0,
        to: 0,
      },
      curBulletId: 0,
      offsetLast: 0,
      events: {
        // '1598889600': [
        //   {
        //     idx: 0,
        //     title: 'ALIPAY 2020 未来已来',
        //     date: '09.01 9:30-10:30上午',
        //     cover: 'https://mp.panstone.group/imgs/upload/evt-9-1-cover.png',
        //     banner: 'https://mp.panstone.group/imgs/upload/evt-9-1-banner.png',
        //   },
        // ],
        // '1600444800': [
        //   {
        //     idx: 0,
        //     title: 'ALIPAY 2020 未来已来',
        //     date: '09.01 9:30-10:30上午',
        //     cover: 'https://mp.panstone.group/imgs/upload/evt-9-1-cover.png',
        //     banner: 'https://mp.panstone.group/imgs/upload/evt-9-1-banner.png',
        //   },
        //   {
        //     idx: 0,
        //     title: 'ALIPAY 2020 未来已来',
        //     date: '09.01 9:30-10:30上午',
        //     cover: 'https://mp.panstone.group/imgs/upload/evt-9-1-cover.png',
        //     banner: 'https://mp.panstone.group/imgs/upload/evt-9-1-banner.png',
        //   },
        // ],
        // '1581609600': [
        //   {
        //     idx: 2,
        //     title: '活动主题',
        //     date: '02.13 9:30-10:30上午',
        //   },
        //   {
        //     idx: 3,
        //     title: '活动主题',
        //     date: '02.13 9:30-10:30上午',
        //   },
        //   {
        //     idx: 4,
        //     title: '活动主题',
        //     date: '02.13 9:30-10:30上午',
        //   },
        //   {
        //     idx: 5,
        //     title: '活动主题',
        //     date: '02.13 9:30-10:30上午',
        //   },
        //   {
        //     idx: 6,
        //     title: '活动主题',
        //     date: '02.13 9:30-10:30上午',
        //   },
        // ],
        // '1581696000': [
        //   {
        //     idx: 7,
        //     title: '活动主题',
        //     date: '02.13 9:30-10:30上午',
        //   },
        // ],
      },
    }
  },
  computed: {
    ...mapState('app', ['mpEventList']),
  },
  watch: {
    mpEventList(val) {
      console.log('mp event', val)
      let list = {}
      let arr = Object.assign([], val)
      arr = arr.sort(this.sortFn)

      let year = []
      arr.map((evt, idx) => {
        console.log(evt.eventTitle, idx)
        let date = new Date(parseInt(evt.startTime))
        const index = date.getFullYear()+'-'+(date.getMonth()+1)

        console.log(index)
        let e = {
          idx: idx,
          title: evt.eventTitle,
          cover: evt.listCover,
          banner: evt.contentCover,
          content: evt.content,
          month: date.getMonth(),
          year: year.indexOf(date.getFullYear()) > -1 ? null : date.getFullYear(),
        }
        year.push(date.getFullYear())

        if (list[`${index}`]) {
          list[`${index}`].push(e)
        } else {
          list[`${index}`] = []
          list[`${index}`].push(e)
        }
      })
     console.log(list)
   
     
      this.events = list
    },
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    to2d(num) {
      num = parseInt(num)
      if (num < 10) {
        return `0${num}`
      } else {
        return num
      }
    },
    sortFn(a, b) {
      return parseInt(b.startTime) - parseInt(a.startTime)
    },
    init() {
      // this.swiper = new Swiper(this.$refs.waterfall, {
      //   direction: 'vertical',
      //   slidesPerView: 'auto',
      //   spaceBetween: 10,
      //   //slidesOffsetAfter: 10,
      //   freeMode: true,
      //   on: {
      //     // progress: (p) => {
      //     //   //console.log(p)
      //     //   this.progress = p
      //     // },
      //     // touchMove: () => {
      //     //   this.updateBullet()
      //     // },
      //     transitionStart: () => {
      //       // if (this.swiper)
      //       //   console.log('trans', this.swiper.wrapperEl.style.transitionDuration)
      //       //this.transitioning = true
      //       Raf.add(this.updateBullet)
      //     },
      //     transitionEnd: () => {
      //       Raf.remove(this.updateBullet)
      //       //console.log('trans end')
      //       //this.transitioning = false
      //     },
      //   },
      // })
      if (!this.$refs.bullet) {
        return
      }
      console.log(this.$refs.bullet)
      this.bulletEls = this.$refs.bullet
      this.wrapperTop = this.$refs.waterfall.getBoundingClientRect().top
      this.wrapperEl = this.$refs.wrapper
      this.bulletH = this.bulletEls[0].getBoundingClientRect().height
      this.bulletOrigPos = this.bulletEls.map((b) => {
        return b.getBoundingClientRect().y - this.wrapperTop
      })
      console.log(this.bulletOrigPos)
    },
    updateBullet() {

      if (!this.curBulletId) {
        return
      }
      const curBullet = this.bulletEls[this.curBulletId]
      const wrapperRect = this.wrapperEl.getBoundingClientRect()
      const prevBulletOrigPos = this.bulletOrigPos[this.curBulletId - 1] || 0
      const curBulletOrigPos = this.bulletOrigPos[this.curBulletId]
      const nextBulletOrigPos =
        this.bulletOrigPos[this.curBulletId + 1] || curBulletOrigPos
      const bulletGap = nextBulletOrigPos - curBulletOrigPos - this.bulletH
      const offsetTop = wrapperRect.top - this.wrapperTop

      // const dir = offsetTop - this.offsetLast
      // this.offsetLast = offsetTop

      // if (dir > 0) {
      // }
      // if (dir < 0) {
      // }
      const pinStart = -curBulletOrigPos
      const pinEnd = -curBulletOrigPos - bulletGap

      if (offsetTop < pinStart) {
        const unset = pinStart - offsetTop
        //const unset2 = curBullet.getBoundingClientRect().top - this.wrapperTop
        //console.log(777, offsetTop, -curBulletOrigPos, unset)
        //this.bulletOfs.to = unset
        //this.bulletOfs.cur += (this.bulletOfs.to - this.bulletOfs.cur) * 0.1
        curBullet.style.transform = `translate3d(0, ${unset}px, 0)`
        console.log(curBullet.getBoundingClientRect().top - this.wrapperTop)
        //curBullet.style.position = 'fixed'
        //curBullet.style.top = this.bulletH + 'px'
        //curBullet.style.left = 0 + 'px'
        if (offsetTop < pinEnd) {
          //console.log(bulletGap, unset)

          if (this.curBulletId < this.bulletEls.length - 1) {
            curBullet.style.transform = `translate3d(0, ${bulletGap}px, 0)`
            this.curBulletId++
          }
        }
        // console.log(
        //   999,
        //   offsetTop,
        //   -curBulletOrigPos - bulletGap,
        //   -prevBulletOrigPos - bulletGap
        // )
      } else {
        curBullet.style.transform = `translate3d(0, 0, 0)`
        if (this.curBulletId > 0) {
          this.curBulletId--
        }
      }

      //console.log(offsetTop)
    },
    updateBullet2() {
      const curBullet = this.bulletEls[this.curBulletId]
      const wrapperRect = this.wrapperEl.getBoundingClientRect()
      const prevBulletOrigPos = this.bulletOrigPos[this.curBulletId - 1] || 0
      const curBulletOrigPos = this.bulletOrigPos[this.curBulletId]
      const nextBulletOrigPos =
        this.bulletOrigPos[this.curBulletId + 1] || curBulletOrigPos
      const bulletGap = nextBulletOrigPos - curBulletOrigPos - this.bulletH
      const offsetTop = wrapperRect.top - this.wrapperTop

      const pinStart = -curBulletOrigPos
      const pinEnd = -curBulletOrigPos - bulletGap

      if (offsetTop < pinStart) {
        const unset = pinStart - offsetTop
        curBullet.style.transform = `translate3d(0, ${unset}px, 0)`
        console.log(curBullet.getBoundingClientRect().top - this.wrapperTop)
        if (offsetTop < pinEnd) {
          curBullet.style.transform = `translate3d(0, ${bulletGap}px, 0)`
          this.curBulletId++
        }
      } else {
        curBullet.style.transform = `translate3d(0, 0, 0)`
        if (this.curBulletId > 0) {
          this.curBulletId--
        }
      }
    },
    onClick(i) {
      console.log(777, i)
      const card = this.$refs.card[i]
      const rect = card.getBoundingClientRect()
      if (rect.y < rect.height) {
        const ofs = rect.y - rect.height
        console.log('!', ofs)
        this.sb.scrollTo({ x: 0, y: this.sb.getState().position.y - ofs })
        //this.sb.scrollTo()
      }
      if (this.activeCard === i) {
        ///console.log(999)
        this.$router.replace('/events/list')
        this.setRouterBack('/')
      } else {
        this.setRouterBack('/events/list')
        this.$router.replace('/events/list/' + i)
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.init()
      // //gsap.ticker.add(this.updateBullet)
      // //gsap.ticker.fps(60)
      // //Raf.add(this.updateBullet)
      //
      // this.observer = new MutationObserver((mutations) => {
      //   // const yoff = mutations[0].oldValue.match(
      //   //   /transform: translate3d\(0px, (\S*)px, 0px\);/
      //   // )[1]
      //   // const dur = mutations[0].oldValue.match(
      //   //   /transition-duration: (\S*)ms;/
      //   // )[1]
      //   // console.log(yoff, dur, mutations)
      //   this.updateBullet()
      // })
      // this.observer.observe(this.$refs.wrapper, {
      //   attributes: true, // attribute changes will be observed | on add/remove/change attributes
      //   attributeOldValue: true, // will show oldValue of attribute | on add/remove/change attributes | default: null
      //
      //   characterData: true, // data changes will be observed | on add/remove/change characterData
      //   characterDataOldValue: true, // will show OldValue of characterData | on add/remove/change characterData | default: null
      //   attributeFilter: ['style'],
      // })
      this.sb = new ScrollBooster({
        viewport: this.$refs.waterfall,
        //content: this.$refs.wrapper,
        scrollMode: 'transform',
        direction: 'vertical',
        pointerDownPreventDefault: false,
        bounce: true,
        onUpdate: (state) => {
          this.updateBullet()
        },
      })
    }, 0)
    //Scrollbar.init(this.$refs.wrapper)
    // this.$refs.waterfall.addEventListener('scroll', this.updateBullet, {
    //   passive: true,
    // })
  },
  destroy() {
    //gsap.ticker.remove(this.updateBullet)
    //Raf.remove(this.updateBullet)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.event-list2
  width: 100%
  height: 100%
  //background: #1664FF
  padding: 0 pxToRem(40)
  .title
    height: 10%
    color: black
    font-size: pxToRem(54)
    //background: aqua
  .waterfall
    height: 90%
    width: 100%
    overflow: hidden
    //background: greenyellow
    //overflow-y: scroll
    //overflow-x: hidden
    //scroll-behavior: smooth
    //-webkit-overflow-scrolling: touch
    .swiper-wrapper
      display: flex
      flex-direction: column
      .section
        position: relative
        width: 100%
        height: auto
        .timeline
          position: absolute
          height: 100%
          width: pxToRem(64)
          background-image: url("~assets/dot.png")
          background-repeat: repeat-y
          background-size: 100% auto
          .bullet
            background: #ffffff
            transition-duration: 0ms
            will-change: trannsform
            width: pxToRem(64)
        .card
          margin-left: pxToRem(110)
          margin-bottom: pxToRem(40)
          width: pxToRem(560)
          height: pxToRem(320)
          //background: #3a54a2
        .year
          font-size: pxToRem(60)
          font-weight: bold
          color: black
          font-family: $ff-number
          margin-bottom: pxToRem(30)
          span
            font-size: pxToRem(50)
            font-family: $ff-cn
</style>
